import { IsNotEmpty, IsString, IsOptional, IsEnum, MaxLength, IsUUID } from 'class-validator';
import { EntityType } from '../../../enums';

export class CreateEntityContactRequestDto {
    @IsNotEmpty()
    @IsUUID()
    contactId: string;

    @IsNotEmpty()
    @IsUUID()
    entityId: string;

    @IsNotEmpty()
    @IsEnum(EntityType)
    entityType: EntityType;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    roleDescription?: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    context?: string;
}
